/**
 * @fileoverview Model for the validity of a given GBP group ID.
 *
 * @author Wyatt Lindquist (wlindquist@yext.com)
 */

export class ValidateGoogleGroupResponse {
  /**
     * @param {{
     *  valid: boolean,
     * }} params
     */
  constructor(params) {
    /** @type {boolean} */
    this.valid = params.valid;
  }

  /**
     * @param {!ValidateGoogleGroupResponseJson} json
     * @return {!ValidateGoogleGroupResponse}
     */
  static fromJSON(json) {
    return new ValidateGoogleGroupResponse({
      valid: json['valid'],
    });
  }
}

/**
   * @dict
   * @typedef {{
   *  valid: boolean,
   * }}
   */
export let ValidateGoogleGroupResponseJson;


